export const getMonth = (i) => {
    return ['января','февраля','марта','апреля','мая','июня','июля','августа','сентября','октября','ноября','декабря'][+i]
};
